// extracted by mini-css-extract-plugin
export default {"pageWrap":"uc-z","fullWidth":"vc-z","heading":"wc-z","fullBleed":"xc-z","hidden":"yc-z"};